import React from 'react';

function DeleteProduct({ ProductData }) {
  return (
    <div>
      <p>Are you sure you want to delete product <strong>{ProductData?.ProductName}</strong>?</p>
    </div>
  );
}

export default DeleteProduct;
